// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { signInCreateNewAccountStyles } from "@insite/content-library/Widgets/SignIn/SignInCreateNewAccount";
import { fontConfig } from "@vanmeter/XDL/constants";
import { xScreen } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

signInCreateNewAccountStyles.signInCreateNewAccountGridContainer = {
    gap: 0,
};

signInCreateNewAccountStyles.signInCreateNewAccountText = {
    css: css`
        margin-bottom: 4px;
        && > p,
        li {
            font-size: ${fontConfig.small.size}px;
            line-height: ${fontConfig.small.lineHeight};
        }
        && > p {
            margin-bottom: 8px;
        }
        ul {
            padding-right: 0;
            margin-left: 12px;
        }
    `,
};

signInCreateNewAccountStyles.createNewAccountButton = {
    buttonType: "outline",
    css: css`
        margin-top: 4px;
        ${({ isFullWidth }: { isFullWidth?: boolean }) =>
            isFullWidth
                ? css`
                      width: 100%;
                  `
                : ""}
        ${xScreen("lte", "sm")} {
            margin-top: 0;
        }
    `,
};

signInCreateNewAccountStyles.checkoutAsGuestButton = {
    variant: "secondary",
    buttonType: "outline",
};

signInCreateNewAccountStyles.signInCreateNewAccountButtonGridItem = {
    width: 12,
    css: css`
        flex-direction: row;
        gap: 10px;
    `,
};

signInCreateNewAccountStyles.signInCreateNewAccountTitle = {
    css: css`
        margin-bottom: 16px;
    `,
};
